export default "__VITE_ASSET__CUObCD9y__"